// validators/union.ts
import { assertSchema, ValidationErrorBuilder } from "../errors.mjs";
import { AbstractValidator } from "../types.mjs";
import { getValidator } from "../utilities.mjs";
var OneOfValidator = class extends AbstractValidator {
  validators;
  constructor(args) {
    super();
    this.validators = args.map((validation) => getValidator(validation));
    assertSchema(this.validators.length > 0, 'At least one validation required in "oneOf"');
  }
  validate(value, options) {
    const builder = new ValidationErrorBuilder();
    for (const validator of this.validators) {
      try {
        return validator.validate(value, options);
      } catch (error) {
        builder.record(error);
      }
    }
    return builder.assert(value);
  }
};
function oneOf(...args) {
  return new OneOfValidator(args);
}
var AllOfValidator = class extends AbstractValidator {
  validators;
  constructor(args) {
    super();
    this.validators = args.map((validation) => getValidator(validation));
    assertSchema(this.validators.length > 0, 'At least one validation required in "allOf"');
  }
  validate(value, options) {
    for (const validator of this.validators) {
      value = validator.validate(value, options);
    }
    return value;
  }
};
function allOf(...args) {
  return new AllOfValidator(args);
}
export {
  AllOfValidator,
  OneOfValidator,
  allOf,
  oneOf
};
//# sourceMappingURL=union.mjs.map
